import { render, staticRenderFns } from "./Consumption.vue?vue&type=template&id=2ffb1fc7&scoped=true"
import script from "./Consumption.vue?vue&type=script&lang=ts"
export * from "./Consumption.vue?vue&type=script&lang=ts"
import style0 from "./Consumption.vue?vue&type=style&index=0&id=2ffb1fc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffb1fc7",
  null
  
)

export default component.exports